import { useEffect, useState, useMemo } from "react";
import { getContacts, markContactAsRead } from "../../utils/api";
import "./AdminContacts.css";

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    loadContacts();
  }, []);

  const loadContacts = async () => {
    const response = await getContacts();
    const list = response?.data?.data ?? response?.data ?? [];
    setContacts(Array.isArray(list) ? list : []);
  };

  const markAsRead = async (id) => {
    await markContactAsRead(id);
    loadContacts();
  };

  // 🔥 сортировка: новые сверху
  const sortedContacts = useMemo(() => {
    return [...contacts].sort((a, b) => {
      return Number(a.isRead) - Number(b.isRead);
    });
  }, [contacts]);

  return (
    <div className="contacts-page">
      <h2 className="contacts-title">Повідомлення</h2>

      {sortedContacts.map((item) => (
        <div key={item.id} className={`contact-card ${item.isRead ? "read" : "unread"}`}>
          <div className="contact-header">
            <h3>{item.name}</h3>

            <span className={`badge ${item.isRead ? "read" : "unread"}`}>
              {item.isRead ? "Прочитано" : "Нове"}
            </span>
          </div>

          <div className="contact-meta">
            <p>
              <strong>Email:</strong> {item.email}
            </p>
            <p>
              <strong>Тема:</strong> {item.topic}
            </p>
          </div>

          <div className="contact-message">{item.message}</div>

          <div className="contact-footer">
            <small>{new Date(item.createdAt).toLocaleString()}</small>

            <button onClick={() => markAsRead(item.id)} disabled={item.isRead} className="btn">
              Позначити як прочитане
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
